import { render, staticRenderFns } from "./ChartSettingsModal.vue?vue&type=template&id=635874a7"
import script from "./ChartSettingsModal.vue?vue&type=script&lang=js"
export * from "./ChartSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./ChartSettingsModal.vue?vue&type=style&index=0&id=635874a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports